// SRZP Program Variables
export const srzpVariables: any = {
    programTitle: "Schulte Roth & Zabel LLP (Partners)",
    effectiveDates: "8/1/2020 - 8/1/2021",
    feeDisclaimer: null,
    EL_Items: [
        "SRZP_EL_Header",
        ["SRZP_EL_3M", "$3,000,000", "$2,000,000", "Paid by Firm"],
        ["SRZP_EL_5M", "$5,000,000", "$2,000,000", "$166"],
        ["SRZP_EL_10M", "$10,000,000", "$2,000,000", "$1,064"],
        ["SRZP_EL_15M", "$15,000,000*", "$2,000,000", "$2,112"],
        ["SRZP_EL_20M", "$20,000,000*", "$2,000,000", "$3,564"],
        ["SRZP_EL_25M", "$25,000,000*", "$2,000,000", "$4,876"]
    ],
    EL_Disclaimers: [
        `<strong>*</strong>A completed Chubb Group Personal Excess Participant Questionnaire is required for any participant who <u>newly elects</u> or <u>enrolls</u> at these limits along with underwriting approval.
        In addition, it is a requirement that your underlying home and automobile coverage be in place with Chubb.
        Current participants are grandfathered in at their expiring limits.`
    ],
    UM_Items: [
        "SRZP_UM_Header",
        ["SRZP_UM_2M", "$2,000,000", "Included above"],
        ["SRZP_UM_3M", "$3,000,000", "$119"],
        ["SRZP_UM_5M", "$5,000,000", "$356"]
    ],
    EPLI_Items: [
        "SRZP_EP_Header",
        ["SRZP_EP_Decline", "By selecting this box, I am declining EPLI Insurance."],
        ["SRZP_EP_250K", "$250,000 per occurrence / $500,000 aggregate*", "$10,000", "$756"],
        ["SRZP_EP_500K", "$500,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,134"]
    ],
    CI_Items: [
        "SRZP_PR_Parent",
        "SRZP_PR_Yes",
        "SRZP_PR_No"
    ]
};

